import { render, staticRenderFns } from "./editCommunity.vue?vue&type=template&id=3ff99b5f&scoped=true"
import script from "./editCommunity.vue?vue&type=script&lang=js"
export * from "./editCommunity.vue?vue&type=script&lang=js"
import style0 from "./editCommunity.vue?vue&type=style&index=0&id=3ff99b5f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ff99b5f",
  null
  
)

export default component.exports